<div class="mr-small-b">
  <fin-expand
    *ngFor="
      let info of 'SERVICE_FORMS.serviceForms.specialAssistanceWizard.infoAccordion' | finLocalization;
      let i = index;
      let last = last
    "
    class="block"
    [class.border-bottom]="last"
    [key]="'special-assistance'"
    [id]="'special-assistance-' + i"
    #expandInfoAcc
  >
    <div class="trigger flex flex--center border-top ps-small-y" #expandTrigger tabindex="-1">
      <div class="flex-1 transform-none medium-type">
        {{ info.title }}
      </div>
      <fcom-icon
        class="flex-1 flex--nogrow rotate icon-medium nordic-blue-900-text"
        [class.rotate-active]="expandInfoAcc.isOpen$ | async"
        [name]="SvgLibraryIcon.CHEVRON_DOWN"
      ></fcom-icon>
    </div>
    <div class="content pr-medium-y font-body-1">
      {{ info.content }}
    </div>
  </fin-expand>
</div>

<div class="button flex">
  <fcom-button [text]="'Continue'" [mode]="ButtonMode.FILL"> </fcom-button>
</div>
